// extracted by mini-css-extract-plugin
export default {"reviews":"Au","yotpo":"Bu","wrapper":"Cu","review_list":"Eu","carousel":"Fu","swiper-slide":"Gu","review":"Hu","title":"Iu","verified":"Ju"};
    if(module.hot) {
      // 1738064238249
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  